module.exports = __webpack_public_path__ + "static/media/hongtoushan_mobile.94aac823.png";